module.exports = __webpack_public_path__ + "static/img/bg2.b7c4473.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg2.png
// module id = zyNI
// module chunks = 0